import Head2 from "../components/Head2"
import Headline from "../components/Headline"
import SmallBoxLink from "../components/SmallBoxLink";
import TextAreaSmall from "../components/TextAreaSmall";
import HeroImage from "../images/HeroImage";
import ImageSet from "./ImageSet";

const components = {
    "TextAreaSmall" : TextAreaSmall,
    "ImageSet" : ImageSet,
    "HeroImage" : HeroImage,
    "SmallBoxLink" : SmallBoxLink
}

const shortNamesToComponents = {
    "copy" : TextAreaSmall,
    "carousel" : ImageSet,
    "hero" : HeroImage,
    "link" : SmallBoxLink
}

const PortfolioCopy = (props) => {
    const { headline, h2, copy, hero, carousel, stack = false } = props;

    const shortNameData = { copy, hero, carousel };

    const layoutBody = () => {
        let lclstack = ['copy'];
        if(!stack) {
            if (hero) {
                lclstack.push('hero');
            }
            if (carousel) {
                lclstack.push('carousel');
            }
        } else {
            lclstack = stack;
        }

        return (
            lclstack.map((itm) => {
                const ComponentToRender = shortNamesToComponents[itm];
                return (
                    <ComponentToRender key={itm} {...shortNameData[itm]} />
                )
            })
        )
    }

    return (
        <div>
            <Headline text={headline} />
            <Head2 text={h2} />
            {layoutBody()}
        </div>
    )
}

export default PortfolioCopy;